export const TYPE_OPTIONS = [
  {
    label: '标准流程&文件',
    value: 0
  },
  {
    label: '操作指引',
    value: 1
  },
  {
    label: '系统公告',
    value: 2
  },
  {
    label: '避坑指南',
    value: 3
  }
]
export const TIME_OPTIONS = [
  {
    label: '永久',
    value: 0
  },
  {
    label: '时间范围',
    value: 1
  }
]
export const BOOL_OPTIONS = [
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
]
export const RULES = {
  type: [
    {
      required: true,
      message: '请选择类型',
      type: 'number'
    }
  ],
  effectiveType: [
    {
      required: true,
      message: '请选择有效时间',
      type: 'number'
    }
  ],
  isMandatory: [
    {
      required: true,
      message: '请选择是否强制弹窗',
      type: 'number'
    }
  ],
  popupTime: [
    {
      required: true,
      message: '请输入限制弹窗时长',
      type: 'number'
    }
  ],
  isDownloadAllowed: [
    {
      required: true,
      message: '请选择是否允许下载',
      type: 'number'
    }
  ],
  releaseScopeArr: [
    {
      required: true,
      message: '请选择发布范围',
      type: 'array'
    }
  ],
  title: [
    {
      required: true,
      message: '请填写标题'
    }
  ],
  content: [
    {
      required: true,
      message: '请填写具体内容'
    }
  ]
}
export const NOTICE_INFO_COLUMNS = [
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '有效时间',
    dataIndex: 'effectiveTimeStr',
    key: 'effectiveTimeStr'
  },
  {
    dataIndex: 'isReadStr',
    key: 'isReadStr',
    slots: {
      title: 'customTitle'
    },
    width: '100px'
  },
  {
    title: '分类',
    dataIndex: 'category',
    key: 'category',
    width: '100px'
  },
  {
    title: '创建人',
    dataIndex: 'creatorName',
    key: 'creatorName'
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreateStr',
    key: 'gmtCreateStr'
  },
  {
    title: '修改人',
    dataIndex: 'modifierName',
    key: 'modifierName'
  },
  {
    title: '修改时间',
    dataIndex: 'gmtModifiedStr',
    key: 'gmtModifiedStr'
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'action'
  }
]
